/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// INDIVIDUAL CLIENTS ARE A FIRM FEATURE, OFF BY DEFAULT (v1_837c). The journey
// for a natural person (intake, checklist, interview, board and verification)
// is not built, so "Who is the client" on Invite Client and Migrate Client is
// shown only to a firm with features.individual_clients set true, and the two
// routes refuse an individual otherwise. The legal form "individual" stays
// available to the MLRO through the legal form pin on the case. Pure.

export const INDIVIDUAL_CLIENTS_FLAG = 'individual_clients';
export const individualClientsEnabled = (features) => !!(features && features[INDIVIDUAL_CLIENTS_FLAG] === true);
export const INDIVIDUAL_CLIENTS_OFF = 'Individual client onboarding is not enabled for this firm.';
